import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { loginDevice, setUrl } from '../store';
import { getContentByMac, getDeviceApi, getDeviceWithCodeApi } from '../api/smartApi';
import DisplayCarousel from '../components/DisplayCarousel';
import KonnektLogo from '../assets/konLogo.png';

const AllDisplays = () => {
  const {playlistId, code, mac}  = useParams();
  const loadData = async () => {
    try {
      let res;
      if(code) {
        res = await getDeviceWithCodeApi(code);
      } else if(mac) {
        res = await getContentByMac(mac);
      } else {
        res = await getDeviceApi(
          'https://backend.konekt.vip/device/getDevice',
          playlistId
        );
      }
      
      setContent(res);
    } catch (error) { 
      console.log(error);
    }
  }

  useEffect(() => {
    setLoading(true)
    loadData()
      .then(res => setLoading(false))
      .catch(err => console.log(err));
    const intervalId = setInterval(() => {
      setLoading(true);
      loadData()
        .then(res => setLoading(false))
        .catch(err => console.log(err));
    }, 10000)

    return () => clearInterval(intervalId)
  }, [])

  const [content, setContent] = useState();
  const [loading, setLoading] = useState(true);
  if(!content || !content.displays || content.displays.length === 0) {
    
    return <div className='w-full h-screen flex flex-col overflow-hidden justify-center items-center bg-white'>
      <img src={KonnektLogo}/>
      <h2 className='text-slate-700 font-bold text-3xl'>www.smart-app.co.il</h2>
      <h2 className='text-slate-900 font-bold text-5xl mt-5'>{content?.code || content?.[0]?.code}</h2>
    </div>
  }
  if(content && content.displays && content.displays.length > 0) {
    return (
      <div style={{
        width:"100%",
        height:"100%",
        overflow:"hidden",
        cursor:"none"
      }}>
        <DisplayCarousel
          displays={content.displays}
          autoplay={content.displays?.length > 1}
          deviceId={content.deviceId}
          showDeviceId={content.showDeviceId || content.showCode}
          deviceCode={content.code}
          displayPosition={content.displayPosition || "1"}
          deviceRotationTime={content.deviceRotationTime ?
            parseInt(content.deviceRotationTime) * 1000 
            : 10000
          }
        />
      </div>
    )
  }
  else {
    console.log(content)
    return <div>Loading...</div>
  }
}

export default AllDisplays